import { REPORT_TYPES } from "helpers/reports";
import React from "react";
import * as reportService from "sources/books/reports";
import MutualSettlements from "./mutualSettlements";
import Show from "./show";

/** Dispatch the existing report URL without leaking Book's service adapter into settlement source selection. */
export default function ReportPage(props) {
    return props.id === REPORT_TYPES.AccountsReceivableReport ? (
        <MutualSettlements {...props} />
    ) : (
        <Show {...props} source={reportService} />
    );
}
